// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';

export interface SendVisitedOnlineCourseRequestPayload {
  id: number; // course id
}

export type SendVisitedOnlineCourseSuccessPayload = {}

export interface SendVisitedOnlineCourseFailPayload {
  error: Error;
}

const sendVisitedOnlineCourseActions = createAsyncAction(
  'elearning/SEND_VISITED_ONLINE_COURSE_REQUEST',
  'elearning/SEND_VISITED_ONLINE_COURSE_SUCCESS',
  'elearning/SEND_VISITED_ONLINE_COURSE_FAIL'
)<SendVisitedOnlineCourseRequestPayload, SendVisitedOnlineCourseSuccessPayload, SendVisitedOnlineCourseFailPayload>();

export { sendVisitedOnlineCourseActions as default};
